var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C7.81444 4.00001 7.63255 4.05164 7.47466 4.14913C7.31678 4.24661 7.18913 4.38611 7.106 4.552L4.106 10.552C4.03631 10.6911 4.00001 10.8445 4 11V15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H6V27C6 27.2652 6.10536 27.5196 6.29289 27.7071C6.48043 27.8946 6.73478 28 7 28H25C25.2652 28 25.5196 27.8946 25.7071 27.7071C25.8946 27.5196 26 27.2652 26 27V16H27C27.2652 16 27.5196 15.8946 27.7071 15.7071C27.8946 15.5196 28 15.2652 28 15V11C28 10.8445 27.9637 10.6911 27.894 10.552L24.894 4.552C24.8109 4.38611 24.6832 4.24661 24.5253 4.14913C24.3675 4.05164 24.1856 4.00001 24 4H8ZM26 11.236V14H22V12H20V14H17V12H15V14H12V12H10V14H6V11.236L8.618 6H23.382L26 11.236ZM13 20H15V18H13V20ZM17 20H19V18H17V20ZM15 23H13V21H15V23ZM17 23H19V21H17V23Z",
    fill: "#7692FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.f34b30826f1f91e9caf1d3f95c36ded2.svg";
export { ForwardRef as ReactComponent };